(function (app, ng) {
    app.component("getContractedComponent",
        {
            templateUrl: "App.Portal/States/CarriersTraining/Components/GetContracted/GetContracted.template.html",
            controller: 'GetContractedController',
            bindings: {
                user: '<',
                userGroup: '<',
                onBehalfOfUserGroup: '<',
            }
        })
        .controller('GetContractedController', ['externalLoading', 'ssoApi', '$window', function (externalLoading, ssoApi, $window) {
            var $ctrl = this;

            $ctrl.checklist = ['Scan of your E&O', 'Scan of a voided check', 'EIN &amp; business address'];

            $ctrl.goToSureLc = function () {

                $ctrl.userGroup = $ctrl.onBehalfOfUserGroup || $ctrl.userGroup;

                if ($ctrl.userGroup && $ctrl.userGroup.AffiliationLink) {
                    $window.open($ctrl.userGroup.AffiliationLink);
                }

                else {
                    var w = $window.open();
                    w.document.write(externalLoading.html);

                    ssoApi.initiateSureLcSso($ctrl.sureLcUser.LastName).then(function (data) {
                        w.document.write(data);
                        w.document.forms.surelc.submit();
                    }, function (error) {
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
                }
            };

            $ctrl.$onInit = function () {
                ssoApi.getSureLcUser().then(function (user) {
                    $ctrl.sureLcUser = user;
                });
            }
        }]);
})(window.app, window.angular); //jshint ignore:line